module.exports = __webpack_public_path__ + "img/acaki9.44f9217b.jpg";